import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { AuthLayout, BrandMark, Button, Cluster, Heading, Stack, Surface, Text } from '../ui';
import { api } from '../lib/api';

/**
 * Public landing (§14). A restrained EHE-branded entry point on the `@/ui` design layer.
 * If the visitor already has a token, send them into the app.
 */
export function LandingPage() {
  const navigate = useNavigate();
  useEffect(() => {
    if (api.token) void navigate({ to: '/app/dashboard' });
  }, [navigate]);

  return (
    <AuthLayout maxWidth="34rem">
      <Surface tone="default" bordered radius="xl" elevation="sm" padding="10">
        <Stack gap="6">
          <Stack gap="4">
            <BrandMark />
            <Stack gap="3">
              {/* Brand-adjacent surface — a tasteful on-brand eyebrow is legitimate here. */}
              <Text
                size="xs"
                weight="bold"
                tone="brand"
                style={{ textTransform: 'uppercase', letterSpacing: '0.12em' }}
              >
                Operator&rsquo;s Console
              </Text>
              <Heading level={1} size="2xl">
                Autonomous AI agents for your inbox, calendar, Drive &amp; CRM
              </Heading>
              <Text tone="secondary" size="lg">
                With human approval on every consequential action — you stay in control while your
                agents do the work.
              </Text>
            </Stack>
          </Stack>
          <Cluster gap="3">
            <Button
              variant="primary"
              size="lg"
              onClick={() => void navigate({ to: '/register' })}
              data-testid="go-register"
            >
              Get started
            </Button>
            <Button variant="secondary" size="lg" onClick={() => void navigate({ to: '/login' })}>
              Sign in
            </Button>
          </Cluster>
        </Stack>
      </Surface>
    </AuthLayout>
  );
}
